import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const YoutubeProcessingDialog = ({ open, onClose, names = [] }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth='sm'>
      <DialogTitle>
        {t('views.selectFilesModal.youtubeProcessingTitle', {
          defaultValue: 'YouTube is being processed',
        })}
      </DialogTitle>
      <DialogContent>
        <Typography variant='body2' sx={{ mb: 1 }}>
          {t('views.selectFilesModal.youtubeProcessingMessage', {
            defaultValue:
              'This YouTube file is still being processed. Please wait a moment and add it to the playlist or screen later.',
          })}
        </Typography>
        {names.length > 0 && (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            {names.map((name, index) => (
              <Typography
                key={`${name}-${index}`}
                variant='caption'
                color='text.secondary'
              >
                {name}
              </Typography>
            ))}
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant='contained'>
          {t('views.selectFilesModal.ok', { defaultValue: 'OK' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default YoutubeProcessingDialog;
